import { Card, Descriptions, Tag, Typography } from 'antd';
import { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useAppSelector } from '@/shared/hooks';

import { organizationsModel } from '@/entities/organizations';

const { Title } = Typography;

type OrganizationInformationByDistributorProps = {
  organizationID: string;
};

export const OrganizationInformationByDistributor: FC<
  OrganizationInformationByDistributorProps
> = (props) => {
  const { organizationID } = props;

  const { formatDate } = useIntl();

  const organization = useAppSelector(
    organizationsModel.selectors.selectById(organizationID),
  );

  const ownerEmail = organization?.OwnerEmail;

  const isDistributor = !!organization?.Distributor;

  return (
    <Card
      style={{ height: '100%' }}
      title={
        <Title level={3} style={{ marginBottom: 0 }}>
          <FormattedMessage
            id="organization.title"
            defaultMessage="Organization Information"
          />
        </Title>
      }
      bordered={false}
      loading={!organization}
    >
      <Descriptions column={1} size="small">
        <Descriptions.Item
          label={
            <FormattedMessage
              id="organization.name"
              defaultMessage="Name"
            />
          }
        >
          {organization?.Name}
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <FormattedMessage
              id="organization.id"
              defaultMessage="ID"
            />
          }
        >
          {organization?.ID}
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <FormattedMessage
              id="global.created"
              defaultMessage="Created"
            />
          }
        >
          {organization?.Created?.At?.seconds &&
            formatDate(
              new Date(
                Number(organization?.Created?.At?.seconds) * 1000,
              ),
              {
                year: 'numeric',
                month: 'long',
                day: '2-digit',
              },
            )}
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <FormattedMessage
              id="organization.country"
              defaultMessage="Country"
            />
          }
        >
          {organization?.Contacts?.Country}
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <FormattedMessage
              id="organization.email"
              defaultMessage="Email"
            />
          }
        >
          {ownerEmail}
        </Descriptions.Item>

        {isDistributor && (
          <Descriptions.Item
            label={
              <FormattedMessage
                id="organization.isDistributor"
                defaultMessage="Is Distributor"
              />
            }
          >
            <Tag color="blue">
              <FormattedMessage
                id="organizations.type.distributor"
                defaultMessage="Distributor"
              />
            </Tag>
            {organization?.Distributor?.Name && (
              <span> - {organization.Distributor.Name}</span>
            )}
          </Descriptions.Item>
        )}
      </Descriptions>
    </Card>
  );
};
